import { setAxiosBaseurl } from "@/plugins/axios";
import { setBaseurl } from "@/utils/globals";
import store from "@/store";

function setEnvironment(server) {
    setAxiosBaseurl(server);
    setBaseurl(server);
    store.commit("setBaseurl", server);
}

export { setEnvironment };
